import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
	top: 0;
	position: relative;
	padding: ${({ theme }) => theme.variables.padding}px;
	display: flex;
	align-items: flex-end;
`;

export const FilterLabelStyled = styled.label`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.13px;
	padding-bottom: ${({ theme }) => theme.variables.padding * 0.25}px;
	display: inline-block;
	width: 100%;
`;

export const SearchInputContainerStyled = styled.div`
	position: relative;
	margin-right: ${({ theme }) => theme.variables.margin}px;
	width: 66%;
`;

export const SearchInputWrapperStyled = styled.div`
	position: relative;
`;

export const SearchInputStyled = styled.input`
	font-size: 16px;
	letter-spacing: 0.15px;
	line-height: 24px;
	padding: ${({ theme }) => theme.variables.padding * 0.5}px;
	border: 2px solid ${({ theme }) => theme.colors.primaryColor};
	background-color: white;
	width: 100%;
`;

export const DropdownSelectContainerStyled = styled.div`
	position: relative;
	width: 33%;
`;

export const DropdownSelectWrapperStyled = styled.div`
	position: relative;
`;

export const DropdownSelectStyled = styled.select`
	font-size: 16px;
	letter-spacing: 0.15px;
	line-height: 24px;
	padding: ${({ theme }) => theme.variables.padding * 0.5}px;
	padding-right: ${({ theme }) => theme.variables.padding * 1.25}px;
	border: 2px solid ${({ theme }) => theme.colors.primaryColor};
	background-color: white;
	appearance: none;
	width: 100%;
	text-transform: capitalize;
`;

export const DropdownOptionStyled = styled.option`
	font-size: 16px;
	letter-spacing: 0.15px;
	line-height: 24px;
	text-transform: capitalize;
`;
